import * as DataService from '@/DataService.js';
import { defineStore } from 'pinia';

/**
 * Men's and women's games live in separate tables, so ids can collide.
 */
export const gameKey = (game) => `${game?.league ?? 'mbb'}-${game?.id}`;

export const basketballStore = defineStore('basketball', {
    state: () => ({
        format: 'ddd M/DD/YYYY h:mm:ssa',
        todaysGames: [],
        gamesOnNow: [],
        lastUpdate: null,
        lastEventAt: null,
        scoreboardGames: [],
        scoreboardIsLive: false,
        scoreboardLeague: 'mbb',
        teams: [],
        mbbConferences: [],
        wbbConferences: [],
        selectedSeason: 2025,
        selectedTeam: null,
        selectedConference: null,
    }),
    actions: {
        setScoreboard(games, { isLive, league }) {
            this.scoreboardGames = games.map((game) => ({ ...game }));
            this.scoreboardIsLive = isLive;
            this.scoreboardLeague = league;
        },
        applyGameUpdate(incoming, receivedAt) {
            if (!incoming?.id) {
                return;
            }
            this.lastUpdate = receivedAt;
            this.lastEventAt = Date.now();

            const key = gameKey(incoming);
            const existing = this.scoreboardGames.find(
                (game) => gameKey(game) === key,
            );
            if (existing) {
                const { home_team, away_team, ...fields } = incoming;
                Object.assign(existing, fields);
                // Keep standings/conference if a payload arrives without them.
                existing.home_team = { ...existing.home_team, ...home_team };
                existing.away_team = { ...existing.away_team, ...away_team };
                return;
            }

            const league = incoming.league ?? 'mbb';
            if (
                this.scoreboardIsLive &&
                ['all', league].includes(this.scoreboardLeague)
            ) {
                this.scoreboardGames.push({ ...incoming });
            }
        },
        setConferenceOnSession(id) {
            // DataService.client.post(`/api/set-conference/${id}`);
        },
        getCurrentSeason() {
            DataService.client
                .get('/api/current-basketball-season')
                .then((d) => {
                    this.selectedSeason = d.data;
                });
        },

        // getConferences() {
        //     DataService.client.get('/bb-conferences')
        //     .then(d => {
        //         this.conferences=d.data;
        //     });
        // },
        // getTeams() {
        //     DataService.client.get(`teams`).then((d) => {
        //             this.mbbTeams=d.data;
        //         }
        //     );
        // },
        teamToNCAA(team) {
            switch (team.toUpperCase()) {
                case 'ALBNY':
                    return 'ALBANY';
                case 'MASLOW':
                    return 'UMASSL';
                case 'BING':
                    return 'BINGHA';
                case 'VERM':
                    return 'VERMNT';
                case 'NHAMP':
                    return 'UNH';
                //njit umbc bryant maine
                default:
                    return team.toUpperCase();
            }
        },
    },
});
